<template>
    <pause-question :question="$t('PAUSE_DELIVERIES_LILY_FREE_QUESTION')" :updateSubscriptionText="$t('PAUSE_DELIVERIES_LILY_FREE_YES')" :continueToPauseText="$t('PAUSE_DELIVERIES_NO_THANKS')" v-model="optionSelected" :errorMessage="errorHandler.get('dislikes-lilies')"/>
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import PreferencesService from '@/services/users/PreferencesService';
import PauseQuestion from '@/components/partials/account/my-delivery-addresses/PauseQuestion';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

let preferencesService = new PreferencesService();
let subscriptionService = new SubscriptionService();

export default {
    name: 'LilyFreeStep',
    components: { PauseQuestion },
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isNextStepClicked: false,
            optionSelected: null,
            stageId: 'lily-free',
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        ...mapGetters({
            userId: 'account/getUserId',
            subscription: 'subscription/getActiveSubscription',
        }),
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
    },
    watch: {
        optionSelected() {
            if (this.optionSelected === 'update') {
                this.goLilyFree();
            } else if (this.optionSelected === 'continue') {
                this.nextStep();
            }
        },
    },
    methods: {
        goLilyFree() {
            preferencesService.updateUserToLilyFree(this.userId, this.subscription.id)
                .then(() => subscriptionService.pauseSubscription({ subscriptionId: this.subscriptionId, reason: this.pauseSurveyAnswer.label, resumeDate: null }))
                .then(() => this.$emit('deliveries-paused', 'lilyFree'))
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
        nextStep() {
            // this.isNextStepClicked = true;
            // this.$emit('input', this.updatedSteps);
            subscriptionService.pauseSubscription({ subscriptionId: this.subscriptionId, reason: this.pauseSurveyAnswer.label, resumeDate: null })
                .then(() => this.$emit('deliveries-paused'))
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
};
</script>
